var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-l border-t border-light pa-4 mt-8",staticStyle:{"background-color":"#F8F8F8","border-top-left-radius":"12px"}},[_vm._v(" © "+_vm._s(_vm.year)+" "+_vm._s(_vm.name)+", All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }